import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup, FormControl, NgForm, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { APIPaymentService } from '../../_services/payment-dues/payment-dues.service';
import { APITemplateService } from '../../_services/template/API-template';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { Constants } from '../../../../_utils/Constants';
import { formatDate } from '@angular/common';
import { APIEntityService } from '../../_services/entity/API-entity';
import 'rxjs/add/observable/interval'
import * as moment from 'moment-timezone';

//below code for Current Data
const now = new Date();
const currentdate = formatDate(now, 'yyyy-MM-dd', 'en-US', '+0530');

@Component({
	selector: 'app-payment-submit',
	templateUrl: './payment-submit.component.html',
	styleUrls: ['./payment-submit.component.css']
})
export class PaymentSubmitComponent implements OnInit {
	entity_id: any;
	entity_legalName: any;
	gst_number: any;
	address: any; //Vijay
	location: any;
	state: any;
	pincode: any;
	email_address: any;
	transaction_amount: any;
	paymentSubmitForm: FormGroup;
	isValid: boolean = false;
	templateIds: Number[] = [];
	amount: any;
	gstNo: any;
	urn: any;
	modulename : any;

	states = []
	gstnumbers = []

	custnongstdiscErrFlag : boolean = false;
	custgstdiscFlag :  boolean = false
	GSTHide: boolean = false;
	MonthEnd: boolean = false;
	Entityerr: boolean = false;
   // custcommondiscFlag :  boolean = false
	//custcommon1discFlag :  boolean = false
	EntityRefNo : any;
	
	submitmodel = { urn: "", entity_id: "", entity_legalname: "", address: "", location: "", state: "", pincode: "", email_address: "", transaction_amount: "" }
	//var statesjson={"01":"Andhra Pradesh"} 
	constructor(private fb: FormBuilder,
		private ps: APIPaymentService,
		private $modal: $ModalManagerService,
		private db: $DBManagerService,
		private _route: ActivatedRoute,
		private es: APIEntityService,


		private router: Router) {
		this.states = this.ps.getstates();

		this._route.queryParams.subscribe((params) => {
			console.log(params)
			this.submitmodel.transaction_amount = this.db.get(Constants.SESSSION_STORAGE, Constants.TRANSACTIONAMOUNT)
			this.submitmodel.urn = this.db.get(Constants.SESSSION_STORAGE, Constants.PAYMENTFORURN)
			this.submitmodel.entity_id = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID)
			this.submitmodel.entity_legalname = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME)
			this.submitmodel.email_address = this.db.get(Constants.SESSSION_STORAGE, Constants.Entity_EmailID)
			this.modulename= this.db.get(Constants.SESSSION_STORAGE, Constants.MODULEFORPAYMENT);
			this.EntityRefNo = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_REF_NO_LOGIN)
			//Added for Entity-Payment
			if(this.modulename == "For Entity Registration" || this.modulename == "For Entity Renewal"){
				this.GSTHide = true;
			}
		});
		//this.router.getCurrentNavigation().extras.state

		console.log("urn", this.submitmodel.urn)
		console.log("entity_id is", this.submitmodel.entity_id)
		console.log("entity_legalName is", this.submitmodel.entity_legalname)
		//this.paymentSubmitForm.controls['entity_id'].setValue(r[0].id)
	}

	get f() { return this.paymentSubmitForm.controls; }

	/*changeState(event){
		console.log("event is",event),
		//get first two characters in GST
		var stateinNum = event.target.value.substring(0,2),
			console.log("stateinNum is",stateinNum),
		
		
					this.gstRegistrationForm.controls['State'].setValue(statesjson(stateinNum));  
	
	} */

	showreceipt = false;
	orderresult = {}
	ngOnInit() {
		this.paymentSubmitForm = this.fb.group({
			urn: ['', ],
			entity_id: ['', [Validators.required]],
			// contemp_id: ['', [Validators.required]],
			entity_legalname: ['', [Validators.required, Validators.maxLength(100), Validators.minLength(3)]],
			gst_number: ['', [Validators.required]],
			//urn: ['', ],
			address: ['', [Validators.required, Validators.maxLength(120), Validators.minLength(3)]],
			location: ['', [Validators.required, Validators.maxLength(100), Validators.minLength(3)]],
			state: ['', [Validators.required]],
			//pincode: ['', [Validators.required, Validators.maxLength(10000), Validators.minLength(6)]],
			pincode: ['', [Validators.required, Validators.pattern("^[1-9][0-9]{5}$")]],
			email_address: ['', [Validators.required]],
			transaction_amount: ['', [Validators.required]],

			custcommondisc: ['', [Validators.requiredTrue]],	
			custcommon1disc: ['', [Validators.requiredTrue]],
			custgstdisc: ['', [Validators.required]],
			custnongstdisc: ['', [Validators.required]],

			//paymentSubmit_content: ['', [Validators.required, Validators.maxLength(250), Validators.minLength(3)]],
		});
		this.paymentSubmitForm.controls['entity_id'].setValue(this.submitmodel.entity_id);
		this.paymentSubmitForm.controls['urn'].setValue(this.submitmodel.urn); 
		this.paymentSubmitForm.controls['entity_legalname'].setValue(this.submitmodel.entity_legalname)
		this.paymentSubmitForm.controls['transaction_amount'].setValue(this.submitmodel.transaction_amount)
		this.initialtxnamount = parseFloat(this.submitmodel.transaction_amount);
		
		this.paymentSubmitForm.controls['transaction_amount'].disable()
		this.paymentSubmitForm.controls['entity_legalname'].disable()
		this.paymentSubmitForm.controls['urn'].disable()

		this.paymentSubmitForm.controls['email_address'].setValue(this.submitmodel.email_address)
		//this.paymentSubmitForm.controls['gst_number'].setValue('0')

		if(this.modulename == "For Entity Registration" || this.modulename == "For Entity Renewal"){
			this.paymentSubmitForm.controls['gst_number'].setValue("0")
		}

		/*this.paymentSubmitForm.controls['custcommondisc'].setValue(true)
		this.paymentSubmitForm.controls['custcommon1disc'].setValue(true)
		this.paymentSubmitForm.controls['custnongstdisc'].setValue(true)
		this.paymentSubmitForm.controls['custgstdisc'].setValue(true)

		this.paymentSubmitForm.controls['custcommondisc'].disable()
		this.paymentSubmitForm.controls['custcommon1disc'].disable()
		this.paymentSubmitForm.controls['custnongstdisc'].disable()
		this.paymentSubmitForm.controls['custgstdisc'].disable()*/
		this.paymentSubmitForm.controls['custnongstdisc'].setValue(false)
		this.paymentSubmitForm.controls['custgstdisc'].setValue(false)
		this.paymentSubmitForm.controls['custcommondisc'].setValue(false)
		this.paymentSubmitForm.controls['custcommon1disc'].setValue(false)

		//this.submitmodel.entity_id = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);

		this.ps.getGSTNumbersByEntityID(this.submitmodel.entity_id).subscribe((res) => {
			this.gstnumbers = res;
		})
		
		this.checkForMonthEnd()
		if(this.modulename == "For Entity Registration" || this.modulename == "For Entity Renewal"){
			this.checkPOI()
		}
		//this.getContentEntityDetails(this.entity_id) //Vijay- to get entity details from DLT
		//	this.getTemplatesByPE() //Vijay- templates registered by pe
		//this.getDiabledFieldsData(); 
	}//end of oninit
	checkPOI(){ 
		 
		let data={
			EntityId : this.submitmodel.entity_id
		}
		this.ps.checkPOInEclassAvailabiltiy(data).subscribe((res) => {
			if(res.result == "Fail"){
				this.Entityerr = true;
				return
			}
			else{
				this.Entityerr = false;
			}
		})
	}
	//Vijay- to get entity details from DLT 
	//getContentEntityDetails(entity_id) {
	// let data = {
	// 	"entity_id": entity_id,
	// }
	// this.es.getContentEntityDetails(data)
	// 	.subscribe(r => {
	// 		this.paymentSubmitForm.controls['entity_id'].setValue(r[0].id);
	// 		this.paymentSubmitForm.controls['entity_id'].enable();
	// 	})
	//this.paymentSubmitForm.controls['entity_id'].setValue(this.entity_id);
	//}
	//Vijay- templates registered by pe
	// getTemplatesByPE() {   
	// 	let query = {  
	// 		EntityID: this.entityId, 
	// 		"Template_Status": "A"
	// 	}
	// 	this.es.getTemplateSummaryMongo(query)      
	// 	.subscribe(r => {
	// 		for(let i=0;i<=r.length-1;i++){
	// 			this.templateIds.push(r[i].Template_ID);

	// 		}
	// 		console.log("getTemplatesByPE ",r);
	// 		console.log("getTemplatesByPE ",this.templateIds);

	// 	}); 
	// }

	// getDiabledFieldsData for diabled fileds
	// getenabledFieldsData() {
	// 	this.ps.GetNewpaymentSubmit(this.entity_id).subscribe(result => {
	// 		console.log("new data " + result);
	// 		this.onChangeDataSource(result);
	// 	})
	// }
	
	checkForMonthEnd(){
		const today = new Date();
		let DateTime = new Date().setDate(today.getDate());
        // let DateTime1=moment(DateTime).add(330,'minutes')
		let DateTime1=moment(DateTime).add(0,'minutes')
		let Month1 = DateTime1.format('M')
        let DateTime2=moment(DateTime1).add(1,'day')
        let Month = DateTime2.format('M')
        if (Month !== Month1){
			this.MonthEnd = true;
		}
		else{
			this.MonthEnd = false;
		}

	}
	
	initialtxnamount = 0;
	changeGST(e, gst) {
		if (e.isUserInput) {
			let amt = this.initialtxnamount;
			if(e.source.value!='0')
			{
			let stateid = parseInt(e.source.value.substr(0, 2))
			this.paymentSubmitForm.controls['state'].setValue(stateid)
			
			
				this.paymentSubmitForm.controls['address'].setValue(gst.Entity_Addr)
				this.paymentSubmitForm.controls['entity_legalname'].setValue(gst.CustLegalName)
				this.paymentSubmitForm.controls['location'].setValue(gst.Entity_City)
				this.paymentSubmitForm.controls['pincode'].setValue(gst.Entity_Pincode)
				this.paymentSubmitForm.controls['email_address'].setValue(gst.Entity_EmailID)

			//	amt = amt + (amt * 18 / 100);
				this.paymentSubmitForm.controls['transaction_amount'].setValue(amt)


				this.paymentSubmitForm.controls['state'].disable()			
				this.paymentSubmitForm.controls['address'].disable()
				this.paymentSubmitForm.controls['entity_legalname'].disable()
				this.paymentSubmitForm.controls['email_address'].disable()
				this.paymentSubmitForm.controls['location'].disable()
				this.paymentSubmitForm.controls['pincode'].disable()
				this.paymentSubmitForm.controls['transaction_amount'].disable()

			}
			else {

				this.paymentSubmitForm.controls['state'].enable()			
				this.paymentSubmitForm.controls['address'].enable()
				this.paymentSubmitForm.controls['entity_legalname'].disable()
				this.paymentSubmitForm.controls['email_address'].disable()
				this.paymentSubmitForm.controls['location'].enable()
				this.paymentSubmitForm.controls['pincode'].enable()
				this.paymentSubmitForm.controls['transaction_amount'].disable()
				this.paymentSubmitForm.controls['transaction_amount'].setValue(this.initialtxnamount)
				this.paymentSubmitForm.controls['address'].setValue('')
			//	this.paymentSubmitForm.controls['entity_legalname'].setValue('')
				this.paymentSubmitForm.controls['location'].setValue('')
				this.paymentSubmitForm.controls['pincode'].setValue('')
				this.paymentSubmitForm.controls['state'].setValue('')
				//this.paymentSubmitForm.controls['email_address'].setValue(gst.Entity_EmailID)

			}
			//console.log(this.state, parseInt(e.source.value.substr(0, 2)))
			// if (this.state === 0) {
			// 	const validators = [Validators.required, Validators.minLength(5)];
			// 	this.paymentSubmitForm.addControl('optionBExtra', new FormControl('', validators));
			// } else {
			// 	this.paymentSubmitForm.removeControl('optionBExtra');
			// }
			//this.paymentSubmitForm.updateValueAndValidity()
		}


	}
	onChangeDataSource(res) {
		//this.paymentSubmitForm.controls['entity_id'].setValue(res.message.Entity_ID)

	}
	dltordernum = ""
	reset() {
		this.router.navigate(['payment-dues']); // enable for final deployment 
		// let order = this.dltordernum;
		// let params = {
		// 	"DLTOrderNumber": order,
		// 	"CustomerID": "ABCDEFG",
		// 	"TxnReferenceNo": "A1B2C3D4E5F6",
		// 	"BankReferenceNo": "AAAAAAAAAAAAA1B2C3D4E5F6",
		// 	"BankID": "ZZZZZZZZZz",
		// 	"TxnAmount": "10000",
		// 	"TxnDate": "09-July-2021",
		// 	"iBPStatus": "SUCCESS",
		// 	"iBPMessage": "Please Perform Digital Consent Acquisition",
		// 	"additionalInfo1": "Banu did"
		// }
		// this.ps.postpaymentresp(params).subscribe((res) => {
		// 	//this.orderresult = res;
		// })
	}
	//for Form submition
	disablesubmit = false;
	changeNonGST(event){
		
		if(event.checked == true){
			this.custnongstdiscErrFlag = false;
		}
		else{
			this.custnongstdiscErrFlag = true;
		}	
	
	}
	onSubmit() {

		this.isValid = true;
		// 1. Call generate Order Number (DLT+PO+YYMM000001) API
		// 	1. Maintain counter table, generate new sequence for each call
		// 	2. Insert order reccord in payment histroty table
		// 2. Take the order num from above call and submit request to payment
		// 3. After submit, we sould call get payment history by dlt ordeer number

		console.log("---------------------this.paymentSubmitForm.invalid--------------", this.paymentSubmitForm.invalid);

		if (this.paymentSubmitForm.invalid) {
			let invalid = [];
			let controls = this.paymentSubmitForm.controls;
			for (const name in controls) {
				if (controls[name].invalid) {
					invalid.push(name);
				}
			}
			return;
		}
		// if(this.modulename == "For Entity Registration" && this.Entityerr == true){
		// 	let data={ 
		// 		EntityId : this.submitmodel.entity_id
		// 	}
		// 	this.ps.updateSecondaryEntityReg(data).subscribe((res) => {
		// 		console.log("res *** ",res)
		// 		if(res.result == "Fail"){
		// 			this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_ID, res.EntityID); 
		// 			this.Entityerr = true;
		// 			this.$modal.errorModal({
		// 				title: 'paymentSubmit alert',
		// 				msg: res.message
		// 			})
		// 			this.router.navigate(['payment-dues'])

		// 			return
		// 		}
		// 	}) 
		// 	return
		// }
		console.log("this.custnongstdiscErrFlag ",this.custnongstdiscErrFlag)
		if(this.modulename == "For Entity Registration" || this.modulename == "For Entity Renewal" ){
			if(this.paymentSubmitForm.controls.custnongstdisc.value == false){
				this.custnongstdiscErrFlag = true;
				return;
			}

		}
		if((this.modulename == "DIGITAL CONSENT ACQUISITION" ) && (this.paymentSubmitForm.controls.gst_number.value == "0") ){
			if(this.paymentSubmitForm.controls.custnongstdisc.value == false){
				this.custnongstdiscErrFlag = true;
				return;
			}
		}


		console.log("---------------------this--------------", this);
		let GSTIN =""
		let urn = this.submitmodel.urn;
		let entity_ID = this.paymentSubmitForm.controls.entity_id.value;
		let CustLegalName = this.paymentSubmitForm.controls.entity_legalname.value;
		if(this.paymentSubmitForm.controls.gst_number.value != "0")
				GSTIN = this.paymentSubmitForm.controls.gst_number.value;
		
		
		let CustAddress1 = this.paymentSubmitForm.controls.address.value;
		let CustLocation = this.paymentSubmitForm.controls.location.value;
		let StateID = this.paymentSubmitForm.controls.state.value;
		let eml = this.paymentSubmitForm.controls.email_address.value;
		let amt = this.paymentSubmitForm.controls.transaction_amount.value;
		let TxnDate = new Date();

		let reqparams = {
			"PaymentForURN": urn,
		//	"Description": "Payment for DLT Registrations",
			"Description": this.modulename,
			"EntityID": entity_ID,
			"PaymentOrderStatus": "INITIATED",
			"CustLegalName": CustLegalName,
			"GSTIN": GSTIN,
			"CustAddress1": CustAddress1,
			"CustLocation": CustLocation,
			"StateID": StateID,
			"EmailAddress": eml,
			"TxnAmount": amt,
			"TxnDate": TxnDate,
			"entRefNo": this.EntityRefNo
		}
		if(this.MonthEnd == true){
			this.$modal.errorModal({
				title: 'paymentSubmit alert',
				msg: "Payment cannot be processed on Month End"
			})
			return ;	
		}
		else{
		this.ps.placeDLTPaymentOrder(reqparams).subscribe(result => {
			
			if (result.status == "Fail") {
						
				this.$modal.errorModal({
					title: 'paymentSubmit alert',
					msg: result.message
				})
			}

			else {
			console.log("new data " + result);
			let dltordernum = result.DLTOrderNumber;
			this.dltordernum = result.DLTOrderNumber;
			let param = { DLTPaymentOrderNumber: dltordernum, TransactionAmount: amt, ReturnResponseURL: "https://ttlprodapim.azure-api.net/pay/ibppayresp", EmailID: eml, SourceIdentifier: "DLTUCC" };
			this.postPayment(param, "https://billpay.tatateleservices.com/BillPayEnterprisePortal/TPValidate")
			this.disablesubmit = true;
			let secs = 0;
			

			let timer = setInterval(() => {
				secs += 10
				let fetchDLTPaymentOrdersub = this.ps.fetchDLTPaymentOrder(dltordernum).subscribe((ress) => {
					let res = ress[0]
					if (res.iBPStatus == "SUCCESS" || res.iBPStatus == "PAYMENT_FAILURE" || secs == 300) {
						clearInterval(timer)
						if (secs == 300) {
							let params = {
								"DLTOrderNumber": dltordernum,
								"PaymentOrderStatus": "TRANSACTION_EXPIRED"
							}
							this.ps.postpaymentresp(params).toPromise().then(() => {
								let fetchDLTPaymentOrdersub = this.ps.fetchDLTPaymentOrder(dltordernum).subscribe((fetchDLTPaymentOrderress) => {
									let fetchDLTPaymentOrderres = fetchDLTPaymentOrderress[0]
									this.showreceipt = true;
									this.orderresult = fetchDLTPaymentOrderres;
									fetchDLTPaymentOrderres.iBPStatus = 'TRANSACTION_EXPIRED'
									fetchDLTPaymentOrderres.CustomerID = ""
									fetchDLTPaymentOrdersub.unsubscribe()
								})
								this.$modal.errorModal({
									title: 'Payment Submit alert',
									msg: 'Previous attempt for payment has been failed. Please re-initiate the request'
								})

							});
						}
						else {
							this.showreceipt = true;
							this.orderresult = res;
						}

						console.log(secs)
						fetchDLTPaymentOrdersub.unsubscribe()
						this.db.set(Constants.SESSSION_STORAGE, Constants.MODULEFORPAYMENT, '');
						//this.router.navigate('payment-receipt');
					}

				})
				//
			}, 10000)
			// setTimeout(() => {
			// 	clearInterval(timer)


			// 	let params = {
			// 		"DLTOrderNumber": dltordernum,
			// 		"PaymentOrderStatus": "TRANSACTION_EXPIRED"
			// 	}
			// 	this.ps.postpaymentresp(params).subscribe((postpaymentrespres) => {
			// 		this.ps.fetchDLTPaymentOrder(dltordernum).subscribe((ress) => {
			// 			let res = ress[0]
			// 			this.showreceipt = true;
			// 			this.orderresult = res;
			// 		})
			// 	})



			// 	//this.orderresult = res;

			// 	//write logic for expiring the transaction***************Important*******************
			// }, 30000)

			// let sub = this.ps.fetchDLTPaymentOrder(dltordernum).interval(5000).subscribe((res) => {
			// 	if (res.iBPStatus == "SUCCESS" || res.iBPStatus == "PAYMENT_FAILURE")
			// 		sub.unsubscribe();

			// })
			
		}
		})
		}
	}

	
	postPayment(obj: any, url: string) {
		var mapForm = document.createElement("form");
		mapForm.target = "_blank";
		mapForm.menubar = "no";
		mapForm.resizable = "no";
		mapForm.location = "no";
		mapForm.status = "no";
		mapForm.scrollbars = "no";
		mapForm.method = "POST"; // or "post" if appropriate
		mapForm.action = url;
		Object.keys(obj).forEach(function (param) {
			var mapInput = document.createElement("input");
			mapInput.type = "hidden";
			mapInput.name = param;
			mapInput.setAttribute("value", obj[param]);
			mapForm.appendChild(mapInput);
		});
		document.body.appendChild(mapForm);
		console.log(document)
		mapForm.submit();
		//document.write(JSON.stringify(document))
	}

	// EntityRegistartion() {
	// 	let EntityID = this.paymentSubmitForm.get("entity_id").value;
	// 	let EntityLegalName = this.paymentSubmitForm.get("entity_legalname").value;
	// 	let GSTNumber = this.paymentSubmitForm.get("gst_number").value;
	// 	// let Content_TemplateIDs = this.paymentSubmitForm.get("contemp_id").value;
	// 	let Address = this.paymentSubmitForm.get("address").value;
	// 	let Location = this.paymentSubmitForm.get("location").value;
	// 	let State = this.paymentSubmitForm.get("state").value;
	// 	let Pincode = this.paymentSubmitForm.get("pincode").value;
	// 	let EmailAddress = this.paymentSubmitForm.get("email_address").value;
	// 	let TransactionAmount = this.paymentSubmitForm.get("transaction_amount").value;

	// 	// const gstRegistrationForm = new FormData();
	// 	// gstRegistrationForm.append('EntityID', EntityID);
	// 	// gstRegistrationForm.append('EntityLegalName', EntityLegalName);
	// 	// gstRegistrationForm.append('GSTNumber', GSTNumber);
	// 	// gstRegistrationForm.append('Address', Address);
	// 	// gstRegistrationForm.append('Location', Location);
	// 	// gstRegistrationForm.append('CST_Brand', CST_Brand);
	// 	// gstRegistrationForm.append('State', State);
	// 	// gstRegistrationForm.append('Pincode', "Pincode");

	// 	// gstRegistrationForm.append('CST_CreatedDate', currentdate);
	// 	let paymentSubmitForm = {
	// 		'EntityID': EntityID,
	// 		'EntityLegalName': EntityLegalName,
	// 		'GSTNumber': GSTNumber,
	// 		//	'gstRegistrationTemplateIDs':gstRegistrationTemplateIDs,
	// 		'Address': Address,
	// 		'Location': Location,
	// 		'State': State,
	// 		'Pincode': Pincode,
	// 		'EmailAddress': EmailAddress,
	// 		'TransactionAmount': TransactionAmount,
	// 		'paymentSubmit_CreatedDate': currentdate

	// 	}
	// 	this.ps.newpaymentSubmit(paymentSubmitForm)
	// 		.subscribe(r => {
	// 			console.log(r)
	// 			if (r.status == "success") {
	// 				//this.showSumbit = false
	// 				this.$modal.successModal({
	// 					title: 'paymentSubmit Template - New Registration',
	// 					msg: 'Your data sumbitted successfully'
	// 				})
	// 				this.isValid = true;
	// 				//this.router.navigateByUrl('/')
	// 			}
	// 			else {
	// 				if (r.message) {
	// 					//this.showSumbit = false
	// 					this.$modal.errorModal({
	// 						title: 'paymentSubmit Template - New Registration',
	// 						msg: r.message
	// 					})
	// 				}

	// 				else {
	// 					this.$modal.errorModal({
	// 						title: 'paymentSubmit Template - New Registration',
	// 						msg: 'Error updating New Registration!'
	// 					})
	// 				}
	// 			}
	// 			// console.log(r);
	// 			// try {
	// 			// 	if (r.status) {
	// 			// 		this.$modal.errorModal({
	// 			// 			title: 'gstRegistration Template - New Registration',
	// 			// 			msg: 'Your data sumbitted successfully. Would you like to complete registration process now?'
	// 			// 		});
	// 			// 	}
	// 			// }
	// 			// catch (e) {
	// 			// 	console.log("catch in registration", e);
	// 			// }
	// 		});
	// }

}
